import { render, staticRenderFns } from "./CurrencySettings.vue?vue&type=template&id=520ff2e8&"
import script from "./CurrencySettings.vue?vue&type=script&lang=js&"
export * from "./CurrencySettings.vue?vue&type=script&lang=js&"
import style0 from "./CurrencySettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports